/**
 * Zoom level below which inactive/non-selected MCC frame toolbars are hidden.
 *
 * MCC pages are much larger than Component Canvas components, so frame
 * breakpoint icon + label still have room to render at very low zoom levels.
 * Keep them visible down to 5% zoom.
 *
 * Single source of truth for MCC's limit, consumed by both the MCC
 * `OpenCanvasFeatureConfig` (which declares it as `toolbarVisibilityZoomLimit`)
 * and the `MultiContextCanvasFramesRenderer` callsite (which passes it to
 * `getIsShowingInactiveToolbars`). The renderer reads this leaf constant
 * directly rather than `OpenCanvas.selectToolbarVisibilityZoomLimit` because it
 * lives in the same package as the feature config, so routing through the
 * aggregate selector would form a config/renderer import cycle.
 */
export const MCC_TOOLBAR_VISIBILITY_ZOOM_LIMIT = 0.05;

/**
 * Screen-space distance (in px) between the top of the viewport and the top
 * of an MCC frame when the viewport is positioned at a frame. Leaves room for
 * the frame's toolbar, which renders above the frame.
 *
 * Single source of truth for MCC's vertical frame offset, consumed by the MCC
 * `OpenCanvasFeatureConfig` default viewport position (as a negative world-Y
 * offset) and by `OpenCanvasPanToSelectionEngine` when panning the active
 * frame into view on MCC activation.
 */
export const MCC_FRAME_TOP_SCREEN_OFFSET = 90;
